export const rules = {
    company_name: [
        { required: true, message: 'Пожалуйста, введите название компании ', trigger: 'blur' },
    ],
    code: [
        { required: true, message: 'Пожалуйста, введите код ', trigger: 'blur' },
    ],
};
